import { type MultiValue } from 'react-select';

import { type OptionType } from '@hivebrite/design-system/Inputs';

export const isOptionType = (value: unknown): value is OptionType =>
  typeof value === 'object' &&
  value !== null &&
  'value' in value &&
  'label' in value;

export const isOptionTypeArray = (
  value: unknown,
): value is MultiValue<OptionType> =>
  Array.isArray(value) && value.every((v) => isOptionType(v));
